/**
 * Documents × ALCOA+ principles: one colour-coded chip per verdict, the
 * overall (worst) verdict first. Clicking a document opens its drill-down.
 */

import { Table, Text, UnstyledButton } from "@mantine/core";
import { QualityStatusChip } from "./QualityStatusChip";
import { PRINCIPLE_LABEL, statusOf, type QualityResult } from "./types";

interface Props {
  result: QualityResult;
  selectedId: string | null;
  onSelect: (documentId: string) => void;
}

export function QualityMatrix({ result, selectedId, onSelect }: Props) {
  return (
    <Table.ScrollContainer minWidth={1150}>
      <Table verticalSpacing="xs" highlightOnHover data-testid="quality-matrix">
        <Table.Thead>
          <Table.Tr>
            <Table.Th miw={180}>Document</Table.Th>
            <Table.Th>Overall</Table.Th>
            {result.principles.map((p) => (
              <Table.Th key={p} style={{ whiteSpace: "nowrap" }}>
                <Text size="xs" fw={600}>
                  {PRINCIPLE_LABEL[p]}
                </Text>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {result.documents.map((d) => (
            <Table.Tr
              key={d.document_id}
              bg={d.document_id === selectedId ? "var(--mantine-color-blue-light)" : undefined}
            >
              <Table.Td>
                <UnstyledButton
                  onClick={() => onSelect(d.document_id)}
                  aria-label={`Show findings for ${d.display_name}`}
                >
                  <Text size="sm" fw={500} style={{ wordBreak: "break-word" }}>
                    {d.display_name}
                  </Text>
                </UnstyledButton>
              </Table.Td>
              <Table.Td>
                <QualityStatusChip status={d.overall} compact />
              </Table.Td>
              {result.principles.map((p) => (
                <Table.Td key={p}>
                  <QualityStatusChip status={statusOf(d, p)} compact />
                </Table.Td>
              ))}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
